import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit
} from '@angular/core';
import { merge } from 'rxjs';
import { MODE } from '../../models';
import {environment} from "../../../environments/environment";
import {EventBusService} from "../../services/event-bus.service";
import {pluralize} from "../pipes/pluralize/pluralize";
import {filter} from "rxjs/operators";
import {SearchProgressComponent} from "../search-progress/search-progress.component";
import {TourIncludeComponent} from "../tours/tour-include/tour-include.component";
import {SearchService} from "../../services/search/search.service";
import {HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig} from "../../config/hotel-tours-list-page.config";

@Component({
  selector: 'app-tours-total',
  templateUrl: environment.mobile ? './tours-total.component.mobile.html' : './tours-total.component.html',
  styleUrls: environment.mobile ? ['./tours-total.component.mobile.scss'] : ['./tours-total.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    SearchProgressComponent,
    TourIncludeComponent,
  ]
})
export class ToursTotalComponent implements OnInit {
  toursCount$ = this.searchService.toursCount$;
  searchProgressTimeout: string;

  info = '';
  isSearchMode = false;
  firstToursFound$ = this.searchService.firstToursFound$;
  showSearchProgress = false;

  // отображать туры списком для мобильной версии
  mobileIsToursListMode = true;

  messages: any = {};

  constructor(
    @Inject(HOTEL_TOURS_PAGE_CONFIG) private hotelToursPageConfig: HotelToursPageConfig,
    private searchService: SearchService,
    private cdRef: ChangeDetectorRef,
    private eventBusService: EventBusService
  ) {
    this.isSearchMode = this.hotelToursPageConfig.mode === MODE.MODE_SEARCH;
    this.messages = Object.assign(
      {},
      this.hotelToursPageConfig.translates.toursTotal,
      {
        pluralTours: this.hotelToursPageConfig.translates.plurals.pluralTours
      }
    );
  }

  ngOnInit() {
    if (this.hotelToursPageConfig.mode === MODE.MODE_SEARCH) {
      this.info = this.messages.infoTextSearch;
    } else {
      this.info = this.messages.infoTextDefault;
    }

    this.searchService.newSearchStarted$
      .pipe(
        filter(searchId => !!searchId)
      )
      .subscribe(() => {
        if (this.showSearchProgress === true) {
          this.showSearchProgress = false;
          this.cdRef.detectChanges();
        }

        this.showSearchProgress = true;
        this.cdRef.detectChanges();
      });


    this.searchService.searchIsDone$
      .subscribe(() => {
        this.showSearchProgress = false;
        this.cdRef.detectChanges();
      });

    merge(
      this.searchService.searchProgressTimeout$,
      this.searchService.postfilterProgressTimeout$
    )
      .subscribe(timeout => {
        this.showSearchProgress = true;
        this.searchProgressTimeout = `${timeout + 1}s`;
        this.cdRef.detectChanges();
      });
  }

  mobileSwitchViewMode() {
    this.mobileIsToursListMode = !this.mobileIsToursListMode;
    this.eventBusService.toggleMap$.next(!this.mobileIsToursListMode);

    this.eventBusService.trackEventInitMap$.next({
      place: 'mobile.tours-total.component',
      date: new Date()
    });
  }

  public tourTotal(tourCount) {
    return pluralize(tourCount, this.messages.pluralTours);
  }
}
